export const delay = (ms: number | string) =>
  new Promise<void>((res) => {
    setTimeout(
      () => {
        res();
      },
      typeof ms === 'number' ? ms : parseInt(ms, 10),
    );
  });
